import React, { useState, useContext, useEffect } from 'react';
import styles from './style';
import { useTheme } from '@mui/material';
import userPool from '../UserPool';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { InputPassword, Input, Button } from '@alquiler-argentina/aa-componentes'
import { Grid, Typography, Container, Checkbox, Divider, FormControlLabel, Dialog } from '@mui/material'
import AACargando from '../../Commons/AACargando';
import isMobile from 'ismobilejs';
import ModalCloseIcon from '../ModalCloseIcon';
import axios from 'axios';
import UserContext from '../ContextUser/Context';
import HistoryHelper from '../../../helpers/HistoryHelper';
import { VerificationCode } from '../VerificationCode/index';
import Footer from '../Footer';
import validator from 'validator';
import * as Sentry from '@sentry/react';


export default function SignUp({ modalOpen, userEmail, onCloseLoginModal, createAnfitrion, esTroya }) {
    // email que viene como parametro en la url
    const emailARegistrar = window.g.emailARegistrar
    const [nombre, setNombre] = useState("");
    const [apellido, setApellido] = useState("");
    const [viewVerification, setStateVerification] = useState(false);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState(emailARegistrar || userEmail || "");
    const [password, setPassword] = useState("");
    const [errorPassword, setErrorPassword]= useState(false);
    const [errorEmail, setErrorEmail]= useState(false);
    const theme = useTheme();
    const classes = styles(theme);
    const { authenticate, getOldCookies, deleteOldCookies } = useContext(UserContext);

    useEffect(() => {
        // si entra al signUp y tiene cookies de cognito o cookies viejas de la pagina las borro
        if(getOldCookies().length){
            deleteOldCookies();
        }
    }, [])
    
    // Función que crea al usuario
    const onCreate = (event) => {
        setLoading(true)
        if(password.length < 8){
            setErrorPassword(true)
            setLoading(false)
            return false
        }
        if(!validator.isEmail(email)){ 
            setErrorEmail(true)
            setLoading(false)
            return false
          }
        setStateVerification(true);
        const attributeList = [];
        const dataNombre = {
            Name: 'name',
            Value: nombre,
        }
        const dataApellido = {
            Name: 'family_name',
            Value: apellido,
        }
        const dataTipo = {
            Name: 'custom:tipo',
            Value: '1',
        }
        const attributeNombre = new CognitoUserAttribute(dataNombre);
        const attributeApellido = new CognitoUserAttribute(dataApellido);
        const attributeTipo = new CognitoUserAttribute(dataTipo);

        attributeList.push(attributeNombre);
        attributeList.push(attributeApellido);
        attributeList.push(attributeTipo);

        userPool.signUp(email, password, attributeList, null, (err, data) => {
            if (err) {
                alert('Problemas en el registro')
                Sentry.captureException(err, 'Something is wrong in SingUp, function signUp');
                setLoading(false)
            } else {
                // Elimino parametro email de la url
                HistoryHelper.replace('email');
                // Hago post de usuario registrado
                axios.post(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, { email: email, tipo: createAnfitrion ? 2 : 1, identity: 1, name: nombre, updated_password: 1 })
                .then((result) => {
                    setLoading(false)
                })
                .catch((err) => console.log(err));
            }
        });
    }
    const onInit = (event) => {
        authenticate(email, password)
            .then( (data) => { 
            })
            .catch((err) => console.log(err))
    };

    if (loading && !modalOpen) {
        return (<div css={classes.aaLoader}><AACargando /></div>)
    }
    const signUpContainer =
        <Container component="main" maxWidth="xs">
            {loading ? <div css={classes.aaLoaderModal}><AACargando /></div> : null}
            {modalOpen && <ModalCloseIcon onClick={onCloseLoginModal} />}
            <div style={loading ? {display: 'none'} : null}>
                {viewVerification ?
                    <VerificationCode createAnfitrion={createAnfitrion ? true : false} esTroya={esTroya ? true : false} onCloseLoginModal={onCloseLoginModal} password={password} modalOpen={modalOpen}  onCreate={onCreate} title='Verificar dirección de correo electrónico' subtitle='Ingresá el código de verificación que recibiste por correo electrónico en ' email={email} />
                    :
                    <div css={classes.paper} >
                        <Grid item xs={12}> 
                            <img src="https://img.alqastatic.com/_img_/isologo.png?w=48" alt="Logo AA" /> 
                        </Grid>
                        <Typography css={classes.textoLogin} variant="h5" component="div">Crea una cuenta</Typography>
                        <form css={classes.form} noValidate>
                            <Typography variant="body2" css={classes.textoForm} component="div">Ingresá tus datos para crear una cuenta</Typography>
                            <Grid container direction='column' spacing={2}>
                                <Grid item xs={12}>
                                    <Input
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="nombre"
                                        label="Nombre"
                                        name="nombre"
                                        value={nombre}
                                        onChange={(event) => setNombre(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Input
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="apellido"
                                        label="Apellido"
                                        name="apellido"
                                        value={apellido}
                                        onChange={(event) => setApellido(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Input
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email"
                                        name="email"
                                        error={errorEmail ? true : false}
                                        helperText={errorEmail ? 'Correo electrónico inválido' : ''}
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <InputPassword label="Contraseña" id="password" name="password" onChange={(event) => { setPassword(event.target.value) }} value={password} fullWidth variant="outlined" error={ errorPassword ? true : false } helperText='Utilizá 8 caracteres para tu contraseña.' />
                                    </div>
                                </Grid>
                            </Grid>
                            <Button
                                onClick={onCreate}
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                css={classes.submit}
                            >
                                Aceptar y continuar
                            </Button>
                            <Divider />
                            <Grid container direction='column' alignItems='flex-start'>
                                <Grid item xs>
                                    <span style={{ fontWeight: 400, color: 'rgba(0, 0, 0, 0.6)', fontSize: '12px', lineHeight: '16px' }}>Alquiler Argentina te va a enviar ofertas exclusivas, contenido, correos electrónicos comerciales y notificaciones push.</span>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                }
             <Footer />
            </div>
        </Container>

    return (
        modalOpen ? (<Dialog scroll='body' css={isMobile.any ? classes.modal : ''} open={modalOpen} onClose={onCloseLoginModal}>{signUpContainer}</Dialog>) : signUpContainer
    )
}
